'use strict'; // eslint-disable-line

module.exports = Container;

/**
 * @type {jQuery|exports|module.exports|Function}
 */
var jQuery = require('jquery');

/**
 * @type {Dropdown|exports|module.exports|Function}
 */
var Dropdown = require('./dropdown');

/**
 * Dropdown general container
 * Acts as mediator for all modules
 * @param {HTMLSelectElement|jQuery} original jQuery object of original select
 * @param {Object} settings Additional options
 * @constructor
 */
function Container(original, settings) {
    this.hasInitialized = false;

    this.$original = jQuery(original);
    this.settings = settings;

    this.$title = jQuery('<span></span>');
    this.$icon = jQuery('<svg class="ui-icon ui-icon_sizeMedium ui-dropdownButton__icon js-dropdownButton__icon">' + '<use xlink:href="img/icons.svg#icon-down"></use>' + '</svg>');

    this.init();
}

Container.prototype.CLASS_BUTTON = 'ui-dropdownButton ui-btn';
Container.prototype.CLASS_BUTTON_MAJOR = 'ui-btn_primary';

Container.prototype.CLASS_TITLE = 'ui-dropdownButton__title';

Container.prototype.CLASS_ICON_SELECTED = 'ui-dropdownButton__icon_selected';

/**
 * Initialize all required objects and render
 * @returns {Container}
 */
Container.prototype.init = function () {
    if (this.hasInitialized) {
        this.initDropdown();

        return this;
    }

    this.$original.wrap(this.settings.wrapper).hide();
    this.$obj = this.$original.parent().addClass(this.CLASS_BUTTON).attr('data-test-selector', 'block-dropDownButton');

    this.$title.addClass(this.CLASS_TITLE);

    this.bindEvents().listenEvents().initDropdown().render();

    this.hasInitialized = true;

    return this;
};

/**
 * Bind events
 * @returns {Container}
 */
Container.prototype.bindEvents = function () {
    var self = this;

    jQuery(document).on('click.toggle.rp.selectDropDown', function (event) {
        self._onClickHandler(event);
    });

    return this;
};

/**
 * Listen events
 * @returns {Container}
 */
Container.prototype.listenEvents = function () {
    var self = this;

    /**
     * Public events
     */
    this.$original.on('updated.rp.selectDropdown', function () {
        self.init();
    }).on('open.rp.selectDropdown', function () {
        self.openDropdown();
    }).on('close.rp.selectDropdown', function () {
        self.closeDropdown();
    });

    /**
     * Internal events
     */
    this.$obj.on('internal.change.rp.selectDropdown', self._changeDropdownHandler());

    return this;
};

/**
 * Apply changes to the DOM
 * @returns {Container}
 */
Container.prototype.render = function () {
    this.$obj.trigger('internal.beforeRender.rp.selectDropdown');

    this.dropdown.$obj.insertAfter(this.$original);
    this.$obj.append(this.$title).append(this.$icon);

    this.$obj.trigger('internal.afterRender.rp.selectDropdown');

    return this;
};

/**
 * Initialize list container
 * @returns {Container}
 */
Container.prototype.initDropdown = function () {
    if (this.dropdown) {
        this.dropdown.init();
    } else {
        this.dropdown = new Dropdown(this);
        this.closeDropdown();
    }

    return this;
};

/**
 * Open dropdown and change button state
 * @returns {Container}
 */
Container.prototype.openDropdown = function () {
    this.dropdown.open();

    this.$obj.addClass(this.CLASS_BUTTON_MAJOR);
    this.$icon.attr('class', jQuery.proxy(function (index, classNames) {
        return classNames + ' ' + this.CLASS_ICON_SELECTED;
    }, this));

    this.$original.trigger('opened.rp.selectDropdown');

    return this;
};

/**
 * Close dropdown and change button state
 * @returns {Container}
 */
Container.prototype.closeDropdown = function () {
    this.dropdown.close();

    this.$obj.removeClass(this.CLASS_BUTTON_MAJOR);
    this.$icon.attr('class', jQuery.proxy(function (index, classNames) {
        return classNames.replace(this.CLASS_ICON_SELECTED, '');
    }, this));

    this.$original.trigger('closed.rp.selectDropdown');

    return this;
};

/**
 * Call standard DOM events on original selector
 * @returns {Function}
 * @private
 */
Container.prototype._changeDropdownHandler = function () {
    var self = this;

    return function (event, index) {
        self.$original.find('option').attr('selected', false);

        var $selectedOriginal = self.$original.find('option:eq(' + index + ')').prop('selected', true).attr('selected', true);

        self.$original.trigger('change', [$selectedOriginal]);

        self.$title.text($selectedOriginal.text());
    };
};

/**
 * Open/close dropdown on click
 * @param {Event} event
 */
Container.prototype._onClickHandler = function (event) {
    var isContains = this.$obj[0].contains(event.target);
    if (isContains) {
        event.preventDefault();
    }

    if (this.dropdown.isOpen()) {
        this.closeDropdown();
    } else if (isContains) {
        this.openDropdown();
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-select/lib/container.js
// module id = 1767
// module chunks = 1